<template lang="html">
  <div class="my-quote-layout">
    <QuoteBreadcrumb />
    <div class="forms-padding">
      <b-row class="row-eq-height">
        <b-col col lg="3" md="3" sm="12" cols="12" class="profile-menu-card">
            <profileMenu />
        </b-col>
        <b-col col lg="9" md="9" sm="12" cols="12" class="forms-quoation-card mb-100">
          <QuoteTab />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import QuoteBreadcrumb from "../components/MyQuote/QuoteBreadcrumb.vue";
import profileMenu from "../components/Profile/profileMenu.vue";
import QuoteTab from "../components/MyQuote/QuoteTab.vue";

export default {
  name: "MyQuote",
  components: {
    QuoteBreadcrumb,
    profileMenu,
    QuoteTab,
  },
  methods: {},
};
</script>
<style lang="css">
.my-quote-layout {
  padding-top: 25vh !important;
}
@media only screen and (max-width: 1077px) {
 .profile-menu-card{
     padding: 0px!important;
  }
  .forms-quoation-card{
      padding: 0px!important;
  }
}
</style>